import type { Event } from '@mb/types';
import { createSlice } from '@reduxjs/toolkit';

interface EventState {
  event: Event | null;
  eventLoaded: boolean;
  eventError: string | null;
  events: Event[];
  eventsLoaded: boolean;
  eventsError: string | null;
}

export const initialState: EventState = {
  event: null,
  eventLoaded: false,
  eventError: null,
  events: [],
  eventsLoaded: false,
  eventsError: null,
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setEventData(state, { payload }) {
      state.event = payload;
    },
    setEventLoaded(state, { payload }) {
      state.eventLoaded = payload;
    },
    setEventError(state, { payload }) {
      state.eventError = payload;
    },
    setEventsData(state, { payload }) {
      state.events = payload;
    },
    setEventsLoaded(state, { payload }) {
      state.eventsLoaded = payload;
    },
    setEventsError(state, { payload }) {
      state.eventsError = payload;
    },
  },
});

export const {
  setEventData,
  setEventsData,
  setEventLoaded,
  setEventsLoaded,
  setEventError,
  setEventsError,
} = eventSlice.actions;

export default eventSlice.reducer;
